type StorageKey = 'autoLogin' | 'jwt-token';

export const getLocalStorage = (item: StorageKey): string | null => {
    const value = localStorage.getItem(item);
    return value;
};

export const setLocalStorage = (key: StorageKey, value: string): void => {
    localStorage.setItem(key, value);
};

export const deleteLocalStorage = (key: StorageKey): void => {
    localStorage.removeItem(key);
};

export const getToken = (): string => {
    return getLocalStorage('jwt-token');
};
